




























































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Thdata from "../../../store/entities/thdata";
import Echarts from "../threaltimedata/Echarts.vue";
import Echartser from "../threaltimedata/Echarts.vue";
import Echartsd from "../threaltimedata/Echarts.vue";
import Echartsl from "../threaltimedata/Echarts.vue";
import Echartsyi from "../threaltimedata/Echarts.vue";
import PageRequest from "@/store/entities/page-request";
// import echarts from 'Echarts'
Vue.prototype.$echarts = Echarts;
class PageThRealTimeDataRequest extends PageRequest {
  AddTime: Date = new Date();
  snid: String;
  locationName: String;
  StartDates: Date = new Date();
  EndDates: Date = new Date();
}
@Component({
  components: { Echarts, Echartser,Echartsd, Echartsl,Echartsyi},
})
export default class AnalyseThrealtimedata extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Date }) EndTime: Date;
  @Prop({ type: String }) snid: String;
  @Prop({ type: String }) locationName: String;
  @Prop({ type: String }) yieldly: string;
  @Prop({ type: String }) years: string;
  @Prop({ type: String }) grade: string;
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  componentKey: number = 10;
  componentKeyhumi: number = 10;
  datalist = [];
  legenddata: string = "";

  y_xAxisdata: string = "";
  er_xAxisdata: string = "";
    d_xAxisdata: string = "";
     l_xAxisdata: string = "";
      yi_xAxisdata: string = "";
  y_seriesdata: string = "";
  er_seriesdata: string = "";
  d_seriesdata: string = "";
  l_seriesdata: string = "";
  yi_seriesdata: string = "";
  yAxisdata: string = "";

  y_serieslist = [];
  er_serieslist = [];
  d_serieslist = [];
  l_serieslist = [];
  yi_serieslist = [];
  
  thdata: Thdata = new Thdata();
  StartTime: string;
  list = [];

  yangtitle: string = "";
  ertitle: string = "";
  dantitle: string = "";
  lvtitle: string = "";
  yititle: string = "";

  title: string = "数据分析";

  yangmessage: string = "";
  ermessage: string = "";
  danmessage: string = "";
  lvmessage: string = "";
  yimessage: string = "";

  datetype: string = "day";
  startDate: Date = new Date();
  endDate: Date = new Date();
  monthDate: Date = new Date();
  polar: string = "";

  OxygenC: Number=0;
  carbondioxideC: Number=0;
  nitrogenC: Number=0;
  chlorinehydrideC: Number=0;
  carbonicoxideC: Number=0;
  Isoxygen: Number=0;
  Iscarbondioxide: Number=0;
  Isnitrogen: Number=0;
  Ischlorinehydride: Number=0;
  Iscarbonicoxide: Number=0;
  Maxoxygen: string = "";
  Minoxygen: string = "";
  Maxcarbondioxide: string = "";
  Maxnitrogen: string = "";
  Maxchlorinehydride: string = "";
  maxcarbonicoxide: string = "";
  async getPage() {
    //filters
    //debugger;
    //let ss=this.value;
    this.pagerequest.AddTime = this.EndTime;
    this.pagerequest.StartDates = this.EndTime;
    this.pagerequest.EndDates = this.EndTime;
    this.pagerequest.snid = this.snid;
    this.list = await this.$store.dispatch({
      type: "gasdata/getPagedLast",
      data: this.pagerequest,
    });
    this.yangtitle = "氧气浓度走势图";
    this.ertitle = "二氧化碳浓度走势图";
    this.dantitle = "氮气浓度走势图";
    this.lvtitle = "磷化氢浓度走势图";
    this.yititle = "一氧化碳浓度走势图";
    let titlelist = ["气体浓度检测"];

    this.y_serieslist.push({
      name: "氧气",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [
            {
              offset: 0,
              color: "rgba(1,191,236)",
            },
            {
              offset: 1,
              color: "rgba(84, 112, 198)",
            },
          ],
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
        },
      },
      markPoint: {
        data: [
          { type: "max", name: "最大值" },
          { type: "min", name: "最小值" },
        ],
      },
    });
    this.er_serieslist.push({
      name: "二氧化碳",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [
            {
              offset: 0,
              color: "rgba(1,191,236)",
            },
            {
              offset: 1,
              color: "rgba(84, 112, 198)",
            },
          ],
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
        },
      },
      markPoint: {
        data: [
          { type: "max", name: "最大值" },
          { type: "min", name: "最小值" },
        ],
      },
    });
     this.d_serieslist.push({
      name: "氮气",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [
            {
              offset: 0,
              color: "rgba(1,191,236)",
            },
            {
              offset: 1,
              color: "rgba(84, 112, 198)",
            },
          ],
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
        },
      },
      markPoint: {
        data: [
          { type: "max", name: "最大值" },
          { type: "min", name: "最小值" },
        ],
      },
    });
     this.l_serieslist.push({
      name: "磷化氢",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [
            {
              offset: 0,
              color: "rgba(1,191,236)",
            },
            {
              offset: 1,
              color: "rgba(84, 112, 198)",
            },
          ],
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
        },
      },
      markPoint: {
        data: [
          { type: "max", name: "最大值" },
          { type: "min", name: "最小值" },
        ],
      },
    });
     this.yi_serieslist.push({
      name: "一氧化碳",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [
            {
              offset: 0,
              color: "rgba(1,191,236)",
            },
            {
              offset: 1,
              color: "rgba(84, 112, 198)",
            },
          ],
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
        },
      },
      markPoint: {
        data: [
          { type: "max", name: "最大值" },
          { type: "min", name: "最小值" },
        ],
      },
    });

    let y_timelist = [];
    let er_timelist = [];
    let d_timelist = [];
    let l_timelist = [];
    let yi_timelist = [];
    // for (let i = 0; i < 24; i++) {
    //   timelist.push(i.toString() + ":00");
    // }

    let datalist_y = [];
    let datalist_er = [];
    let datalist_d = [];
    let datalist_l = [];
    let datalist_yi = [];

    for (let entry of this.list) {
      
      if(entry.gas_type==1){
        datalist_y.push(entry.concentration);
        y_timelist.push(
        this.GetDays(entry.addtime) + " " + this.GetMinutes(entry.addtime)
      );
      }
      if(entry.gas_type==2){
        datalist_er.push(entry.concentration);
         er_timelist.push(
        this.GetDays(entry.addtime) + " " + this.GetMinutes(entry.addtime)
      );
      }
      if(entry.gas_type==3){
        datalist_d.push(entry.concentration);
         d_timelist.push(
        this.GetDays(entry.addtime) + " " + this.GetMinutes(entry.addtime)
      );
      }
      if(entry.gas_type==4){
        datalist_l.push(entry.concentration);
         l_timelist.push(
        this.GetDays(entry.addtime) + " " + this.GetMinutes(entry.addtime)
      );
      }
      if(entry.gas_type==5){
        datalist_yi.push(entry.concentration);
         yi_timelist.push(
        this.GetDays(entry.addtime) + " " + this.GetMinutes(entry.addtime)
      );
      }
    }
    this.yangmessage = datalist_y[datalist_y.length - 1];
    this.ermessage = datalist_er[datalist_er.length - 1];
    this.danmessage = datalist_d[datalist_d.length - 1];
    this.lvmessage = datalist_l[datalist_l.length - 1];
    this.yimessage = datalist_yi[datalist_yi.length - 1];
    this.y_serieslist[0].data = datalist_y;
    this.er_serieslist[0].data = datalist_er;
    this.d_serieslist[0].data = datalist_d;
    this.l_serieslist[0].data = datalist_l;
    this.yi_serieslist[0].data = datalist_yi;

    this.legenddata = JSON.stringify(titlelist);
    this.y_seriesdata = JSON.stringify(this.y_serieslist);
    this.er_seriesdata = JSON.stringify(this.er_serieslist);
    this.d_seriesdata = JSON.stringify(this.d_serieslist);
    this.l_seriesdata = JSON.stringify(this.l_serieslist);
    this.yi_seriesdata = JSON.stringify(this.yi_serieslist);

    this.y_xAxisdata = JSON.stringify(y_timelist);
    this.er_xAxisdata = JSON.stringify(er_timelist);
    this.d_xAxisdata = JSON.stringify(d_timelist);
    this.l_xAxisdata = JSON.stringify(l_timelist);
    this.yi_xAxisdata = JSON.stringify(yi_timelist);
    this.showEcharts();
  }
  get analyse() {
    return this.$store.state.gasequipment.analyse;
  }
  async getThreshold() {
    var thresholdId;
    this.pagerequest.snid = this.snid;
    var elist = await this.$store.dispatch({
      type: "gasequipment/getPageBymac",
      data: this.pagerequest,
    });

    if (elist.length > 0 && elist[0].gId != "") {
      thresholdId = elist[0].gId;
    }
    var threshold = await this.$store.dispatch({
      type: "gasthreshold/get",
      id: thresholdId,
    });
    this.Maxoxygen = threshold.maxoxygen;
    this.Minoxygen = threshold.minoxygen;
    this.Maxcarbondioxide = threshold.maxcarbondioxide;
    this.Maxnitrogen = threshold.maxnitrogen;
    this.Maxchlorinehydride = threshold.maxchlorinehydride;
    this.maxcarbonicoxide = threshold.maxcarbonicoxide;
  }
  GetMinutes(time) {
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getHours()) +
      ":" +
      this.GetBqMinutes(date.getMinutes());
    return Str;
  }
  GetDays(time) {
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getMonth() + 1) +
      "." +
      this.GetBqMinutes(date.getDate());
    return Str;
  }
  GetBqMinutes(str) {
    if (str.toString().length == 1) {
      return "0" + str;
    }
    return str;
  }
  visibleChange(value: boolean) {
    // this.ThisThPaged();
    if (!value) {
      this.Isoxygen = 0;
      this.Iscarbondioxide = 0;
      this.Isnitrogen = 0;
      this.Ischlorinehydride = 0;
      this.Iscarbonicoxide = 0;
      this.$emit("input", value);
      this.$emit("title", this.locationName);
    } else {
      // this.thdata = Util.extend(
      //   true,
      //   {},
      //   this.$store.state.thdata.analyseThdata
      // );
      this.Isoxygen = 0;
      this.Iscarbondioxide = 0;
      this.Isnitrogen = 0;
      this.Ischlorinehydride = 0;
      this.Iscarbonicoxide = 0;
      let list = this.$store.state.gasequipment.analyseGasequipment;
      this.OxygenC = list.oxygenC;
      this.carbondioxideC = list.carbondioxideC;
      this.nitrogenC = list.nitrogenC;
      this.chlorinehydrideC = list.chlorinehydrideC;
      this.carbonicoxideC = list.carbonicoxideC;

      this.Isoxygen = list.isoxygen;
      this.Iscarbondioxide = list.iscarbondioxide;
      this.Isnitrogen = list.isnitrogen;
      this.Ischlorinehydride = list.ischlorinehydride;
      this.Iscarbonicoxide = list.iscarbonicoxide;
      this.getPage();
      this.getThreshold();
    }
  }

  cancel() {
    //this.getPage();
    this.$emit("input", false);
  }

  showEcharts() {
    this.componentKey += 1;
    this.componentKeyhumi += 1;
  }
  GetByDate() {
    if (
      this.pagerequest.StartDates.toString() != "" &&
      this.pagerequest.EndDates.toString() != ""
    ) {
      this.pagerequest.snid = this.snid;
      this.GetPageByDate();
    }
  }
  GetByMonth() {
    if (this.monthDate.toString() != "") {
      var currentY = this.monthDate.getFullYear();
      var currentM = this.monthDate.getMonth() + 1;
      var lastM = new Date(currentY, currentM, 0);
      var lastS = new Date(currentY, currentM - 1);
      this.pagerequest.StartDates = lastS;
      this.pagerequest.EndDates = lastM;
      this.pagerequest.snid = this.snid;
      this.GetPageByDate();
    }
  }
  async GetPageByDate() {
    this.list = await this.$store.dispatch({
      type: "gasdata/getPageByDate",
      data: this.pagerequest,
    });
    this.yangtitle = "氧气浓度走势图";
    this.ertitle = "二氧化碳浓度走势图";
    this.dantitle = "氮气浓度走势图";
    this.lvtitle = "磷化氢浓度走势图";
    this.yititle = "一氧化碳浓度走势图";
    let titlelist = ["气体浓度检测"];

   this.y_serieslist.push({
      name: "氧气",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [
            {
              offset: 0,
              color: "rgba(1,191,236)",
            },
            {
              offset: 1,
              color: "rgba(84, 112, 198)",
            },
          ],
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
        },
      },
      markPoint: {
        data: [
          { type: "max", name: "最大值" },
          { type: "min", name: "最小值" },
        ],
      },
    });
    this.er_serieslist.push({
      name: "二氧化碳",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [
            {
              offset: 0,
              color: "rgba(1,191,236)",
            },
            {
              offset: 1,
              color: "rgba(84, 112, 198)",
            },
          ],
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
        },
      },
      markPoint: {
        data: [
          { type: "max", name: "最大值" },
          { type: "min", name: "最小值" },
        ],
      },
    });
     this.d_serieslist.push({
      name: "氮气",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [
            {
              offset: 0,
              color: "rgba(1,191,236)",
            },
            {
              offset: 1,
              color: "rgba(84, 112, 198)",
            },
          ],
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
        },
      },
      markPoint: {
        data: [
          { type: "max", name: "最大值" },
          { type: "min", name: "最小值" },
        ],
      },
    });
     this.l_serieslist.push({
      name: "磷化氢",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [
            {
              offset: 0,
              color: "rgba(1,191,236)",
            },
            {
              offset: 1,
              color: "rgba(84, 112, 198)",
            },
          ],
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
        },
      },
      markPoint: {
        data: [
          { type: "max", name: "最大值" },
          { type: "min", name: "最小值" },
        ],
      },
    });
     this.yi_serieslist.push({
      name: "一氧化碳",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [
            {
              offset: 0,
              color: "rgba(1,191,236)",
            },
            {
              offset: 1,
              color: "rgba(84, 112, 198)",
            },
          ],
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
        },
      },
      markPoint: {
        data: [
          { type: "max", name: "最大值" },
          { type: "min", name: "最小值" },
        ],
      },
    });

     let y_timelist = [];
    let er_timelist = [];
    let d_timelist = [];
    let l_timelist = [];
    let yi_timelist = [];
    // for (let i = 0; i < 24; i++) {
    //   timelist.push(i.toString() + ":00");
    // }

    let datalist_y = [];
    let datalist_er = [];
    let datalist_d = [];
    let datalist_l = [];
    let datalist_yi = [];

    for (let entry of this.list) {
      
      if(entry.gas_type==1){
        datalist_y.push(entry.concentration);
        y_timelist.push(
        this.GetDays(entry.addtime) + " " + this.GetMinutes(entry.addtime)
      );
      }
      if(entry.gas_type==2){
        datalist_er.push(entry.concentration);
         er_timelist.push(
        this.GetDays(entry.addtime) + " " + this.GetMinutes(entry.addtime)
      );
      }
      if(entry.gas_type==3){
        datalist_d.push(entry.concentration);
         d_timelist.push(
        this.GetDays(entry.addtime) + " " + this.GetMinutes(entry.addtime)
      );
      }
      if(entry.gas_type==4){
        datalist_l.push(entry.concentration);
         l_timelist.push(
        this.GetDays(entry.addtime) + " " + this.GetMinutes(entry.addtime)
      );
      }
      if(entry.gas_type==5){
        datalist_yi.push(entry.concentration);
         yi_timelist.push(
        this.GetDays(entry.addtime) + " " + this.GetMinutes(entry.addtime)
      );
      }
    }
    this.yangmessage = datalist_y[datalist_y.length - 1];
    console.log(this.yangmessage);
    this.ermessage = datalist_er[datalist_er.length - 1];
    this.danmessage = datalist_d[datalist_d.length - 1];
    this.lvmessage = datalist_l[datalist_l.length - 1];
    this.yimessage = datalist_yi[datalist_yi.length - 1];
    this.y_serieslist[0].data = datalist_y;
    this.er_serieslist[0].data = datalist_er;
    this.d_serieslist[0].data = datalist_d;
    this.l_serieslist[0].data = datalist_l;
    this.yi_serieslist[0].data = datalist_yi;

    this.legenddata = JSON.stringify(titlelist);
    this.y_seriesdata = JSON.stringify(this.y_serieslist);
    this.er_seriesdata = JSON.stringify(this.er_serieslist);
    this.d_seriesdata = JSON.stringify(this.d_serieslist);
    this.l_seriesdata = JSON.stringify(this.l_serieslist);
    this.yi_seriesdata = JSON.stringify(this.yi_serieslist);
    this.y_xAxisdata = JSON.stringify(y_timelist);
    this.er_xAxisdata = JSON.stringify(er_timelist);
    this.d_xAxisdata = JSON.stringify(d_timelist);
    this.l_xAxisdata = JSON.stringify(l_timelist);
    this.yi_xAxisdata = JSON.stringify(yi_timelist);
    this.showEcharts();
  }
}
